 <template>
 <div v-role="roles">
         <v-progress-linear  style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>

   <div>
  <v-data-table
    :headers="headers"
    :items="professores"

    :sort-desc="true"

    class="elevation-1"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">

        <v-toolbar-title class="hidden-sm-and-down">
          Associar Professor a Turma

        </v-toolbar-title>

        <v-divider class="mx-8  hidden-sm-and-down" inset vertical></v-divider>

        <!--  search  -->
        <div v-if="$store.state.hasMessage" :class="$store.state.classMessage">
          {{ $store.state.textMessage }}
        </div>

        <div class="flex-grow-1"></div>

        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
        <!-- end  search  -->

        <v-divider class="mx-4 hidden-sm-and-down" inset vertical></v-divider>
 <v-btn  v-if="search"  @click="iniprofessores(search)" text icon color="green">
              <v-icon>cached</v-icon>
            </v-btn>

        <v-spacer></v-spacer>
        <v-dialog v-model="dialog" max-width="800px">

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }} </span>
              <spacer></spacer>
               <v-progress-circular v-if="progresso"
                    color="green"
                    indeterminate
                  ></v-progress-circular>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-form ref="form" v-model="formValid" lazy-validation>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <div
                        v-if="$store.state.hasMessage"
                        :class="$store.state.classMessage"
                      >
                        {{ $store.state.textMessage }}
                      </div>

                    </v-col>
                    <v-col v-if="false" cols="12" sm="12" md="6">
                      <v-text-field

                        v-model="editedItem.idFuncionario"
                        label="cod"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                    <v-text-field
                      v-model="nome_professor"
                      :disabled="true"
                      label="Nome do Professor"
                      required
                    ></v-text-field>

                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                       <v-combobox
                        v-model="editedItem.curso"
                        item-value="idCurso"
                        item-text="descricao"
                          @change="loadTurmaComb"
                          @click="loadTurmaComb"
                        :items="cursos"
                        chips
                        label="Curso"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                     <v-combobox  id="turma"
                        v-model="editedItem.turma"
                        item-value="pkturma"
                        item-text="turmadescricao"
                         @change="loadDiscpilanComb"
                          @click="loadDiscpilanComb"
                        :items="turmasFiltered"
                        chips
                        label="Turma"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">

                         <v-combobox  id="turma"
                        v-model="editedItem.iddisciplina"
                        item-value="iddisciplina"
                        item-text="descricao"
                        :items="disciplinasFiltered"
                        chips
                        label="Disciplina"
                      ></v-combobox>

                    </v-col>
                  </v-row>
                </v-form>
              </v-container>
            </v-card-text>

            <v-card-actions>

              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn v-if="!replace"
                color="blue darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save"
                >Save</v-btn
              >

               <v-btn v-if="replace"
                color=" darken-1"
                :disabled="
                  !(formValid)
                "
                text
                @click="save(true)"
                >Substituir O professor</v-btn
              >

            </v-card-actions>
          </v-card>
        </v-dialog>

  <!-- ==========================================DIALOGO MOSTRANDO OS DADOS DO PROFESSOR ============ -->

               <v-dialog v-model="dialog2" max-width="800px">

          <v-card>
            <v-card-title>
              <span small > {{nome_professor}} - {{profediscinas.length}} disciplinas</span>
            </v-card-title>

            <v-card-text>
              <v-container>

                      <v-data-table
                        :headers="headers2"
                        :items="profediscinas"
                      >

                      </v-data-table>

              </v-container>
            </v-card-text>

            <v-card-actions>

              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog2=false">Cancel</v-btn>

            </v-card-actions>
          </v-card>
        </v-dialog>

  <!-- ==========================================DIALOGO MOSTRANDO OS DADOS DO PROFESSOR ============ -->

      </v-toolbar>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon  @click="AddItem(item)" dark color="primary">add</v-icon>
      <v-icon small class="mr-2" @click="editItem(item)">info</v-icon>
    </template>
    <template v-slot:no-data>
      no data
    </template>
  </v-data-table>
 </div>
 </div>
</template>
<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {
  data: () => ({
    roles: 'func',
    replace: false,
    disciplinas: [],
    profdisciplinasNovo: [],
    disciplinasFiltered: [],
    professordiscijaexiste: [],
    text: '',
    flag_curso: '',
    progresso: false,
    formValid: true,
    isLoading: false,
    nome_professor: '',
    turmasAll: [],
    dialog2: false,
    turmasFiltered: [],
    search: '',
    cursos: [],
    notaRules: [
      // this.value.replace(/[^\d]/, ''),
      v => (v >= 0 && v <= 100) || 'valor da sala invalida',
      v => !!v || 'campo obrigatório.',
      v => !isNaN(v) || 'not number ',

      v => v.length <= 2 || 'valor inválido'
    ],
    professores: [],
    profediscinas: [],
    dialog: false,
    professor_filtrado: [],
    headers: [
      {
        text: 'Nome',
        align: 'left',
        sortable: false,
        value: 'nome'
      },

      { text: 'Código Professor', value: 'idProfessor' },
      { text: 'Código Pessoa', value: 'idPessoa' },
      { text: 'Actions', value: 'action', sortable: false }
    ],

    headers2: [

      { text: 'Curso', value: 'curso' },
      { text: 'Disciplina', value: 'descricao' },
      { text: 'Turma', value: 'turma' }
    ],

    editedIndex: -1,
    editedItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      idfuncionario: null,
      iddisciplina: 0,
      idpessoa: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''

    },
    defaultItem: {
      idProfessorDisciTurma: 0,
      curso: 0,
      iddisciplina: 0,
      professor: 0,
      turma: 0,
      desciplinaDescricao: ''
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Atribuir Disciplina ao Professor' : 'Editar'
    }

  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    // check if classe has been selected otherwise send back to painel to select
    this.iniprofessores()
    this.initprofdisc()
    this.initializeCursos()
    this.initializeturmasAll()
    this.initializedisciplinas()
  },

  methods: {

    async initprofdisc (search) {
      let payload
      try {
        this.isLoading = true
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.profediscinas = await axios
          .get('/professordiscFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },

    async AddItem (item) {
      this.dialog = true
      this.nome_professor = item.nome
    },

    async iniprofessores (search) {
      let payload
      try {
        this.isLoading = true
        if (!search) {
          payload = '{"find":"all"}'
        } else {
          payload = '{"find":"' + search + '"}'
        }
        this.professores = await axios
          .get('/professorFindAll/' + payload)
          .then(res => res.data)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      }
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializedisciplinas () {
      try {
        this.isLoading = true
        this.disciplinas = await axios
          .get('/disciplinaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    loadDiscpilanComb (turma) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.disciplinasFiltered = this.disciplinas.filter(t => t.idCurso === turma.idCurso && t.anoacademico === turma.idAno_Academico)
      this.$nextTick(() => { this.editedItem.iddisciplina = undefined })
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },

    async initializeturmasAll () {
      try {
        this.isLoading = true
        this.turmasAll = await axios
          .get('/turmaFindAll/')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    editItem (item) {
      this.dialog2 = true
      this.nome_professor = item.nome
      this.initprofdisc(item.nome)
      this.editedIndex = this.profediscinas.indexOf(item)
      this.editedItem = Object.assign({}, item)
    },

    deleteItem (item) {
      const index = this.profediscinas.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.profediscinas.splice(index, 1)
    },

    close () {
      this.replace = false
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save (replace) {
      this.professordiscijaexiste = this.profediscinas.filter(
        p => p.iddisciplina === this.editedItem.iddisciplina.iddisciplina && p.turma === this.editedItem.turma.turmadescricao
      ) // if the id is not there then check for BI in collection before create new record if BI is in the collection. the entry already exist, if not insertOne

      if (!this.professordiscijaexiste.length > 0 || this.editedItem.idProfessorDisciTurma > 0 || replace === true) {
        this.saveprof(replace)
      } else {
        this.replace = true
        this.$store.dispatch('textMessage', {
          msg: this.professordiscijaexiste[0].nome + ' é o professor que  lecciona  ' + this.editedItem.iddisciplina.descricao.toUpperCase() + ' na turma  ' + this.editedItem.turma.turmadescricao,
          classMessage: 'msgError',
          timeout: 7000
        })
      }
    },

    async ObterIdFuncionario (valor) {
      try {
        this.editedItem.idfuncionario = await axios
          .get('/ObterIdFuncionario/' + valor)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      if (this.editedItem.idfuncionario != null) { this.ObterIdPessoa(this.editedItem.idfuncionario) }
    },

    async ObterIdPessoa (valor) {
      try {
        this.editedItem.idpessoa = await axios
          .get('/ObterIdPessoa/' + valor.idFuncionario)
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    Actualizar (replace) {
      if (this.professordiscijaexiste.length) {
        let indice = this.profediscinas.indexOf(this.professordiscijaexiste[0])
        this.profediscinas.splice(indice, 1)
      }
    },

    async saveprof (replace) {
      if (this.professordiscijaexiste.length) {
        var params = {
          idProfessorDisciTurma: (this.professordiscijaexiste.length) ? this.professordiscijaexiste[0].idProfessordisciturma : 0,
          idTurma: this.editedItem.turma.idTurma,
          iddisciplina: this.editedItem.iddisciplina.iddisciplina,
          idProfessor: this.professor_filtrado[0].idProfessor,
          fkTurma: this.editedItem.turma.pkTurma,
          desciplinaDescricao: this.editedItem.iddisciplina.descricao,
          idpessoa: this.professor_filtrado[0].idPessoa

        }
      } else {
        try {
          // eslint-disable-next-line no-unused-vars
          let params =
         {
           idProfessorDisciTurma: 0,
           idTurma: this.editedItem.turma.idTurma,
           iddisciplina: this.editedItem.iddisciplina.iddisciplina,
           idProfessor: this.professor_filtrado[0].idProfessor,
           fkTurma: this.editedItem.turma.pkTurma,
           desciplinaDescricao: this.editedItem.iddisciplina.descricao,
           idpessoa: this.professor_filtrado[0].idPessoa
         }
        } catch (error) {
        }
      }
      try {
        // eslint-disable-next-line camelcase
        let cor_mensagem = 'msgError'
        let msg = await axios
          .post('/professordisciInsertOrUpdate', params)
          .then(res => res.data)
        this.progresso = false
        // this.text = msg[1].insertId

        // Verificação da mensagem retornada pelo server
        if (msg.length) {
          let erro = msg[0]
          this.text = 'Ocorreu um erro ao tentar efectuar a operação.\n' + erro[0].Message
          // eslint-disable-next-line camelcase
          cor_mensagem = 'msgError'
          this.progresso = false
        } else {
          this.text = 'Operação efectuada com sucesso.'
          // eslint-disable-next-line camelcase
          cor_mensagem = 'msgSucess'
          this.Actualizar(replace)
          // Adiciona os dados na coleção
          let coll = {
            nome: this.professor_filtrado[0].nome,
            descricao: this.editedItem.iddisciplina.descricao,
            turma: this.editedItem.turma.turmadescricao,
            periodo: this.editedItem.turma.periodo,
            curso: this.editedItem.turma.curso,
            anolectivo: this.editedItem.turma.anoLectivo
          }
          this.progresso = false
          this.profediscinas.unshift(coll)
          this.close()
        }
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: cor_mensagem,
          timeout: 4000
        })
      } catch (error) {
        this.isLoading = false

        this.text = error.message
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 8000
        })
      }
    }

  }
}
</script>
